export const environment = {
  production: true,
  backendBase: '/api',
  apiVersion: 'v1',
  backend: '',
  keycloak: {
    issuer: '/auth/',
    realm: 'Portail',
    clientId: 'portail-frontend'
  }
};

environment.backend = environment.backendBase + '/' + environment.apiVersion;
